import { Gauge, Headset, History, Zap, Tv, Smartphone, Tablet, Cast, Laptop, Usb } from "lucide-react";
import { Reveal } from "./Reveal";
import { SectionHead } from "./SectionHead";
import { IMAGES } from "@/data/site";

const card =
  "group h-full rounded-3xl border border-white/10 bg-surface p-7 transition-[border-color,transform,box-shadow] hover:-translate-y-1 hover:border-neon/30 hover:shadow-[0_24px_60px_-24px_rgba(0,240,255,0.3)]";

const devices = [
  { icon: Tv, label: "Smart TV" },
  { icon: Smartphone, label: "Celular" },
  { icon: Tablet, label: "Tablet" },
  { icon: Cast, label: "Chromecast" },
  { icon: Laptop, label: "PC / Mac" },
  { icon: Usb, label: "Fire Stick" },
];

export const Benefits = () => (
  <section id="beneficios" className="relative py-24 sm:py-28" data-testid="benefits-section">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <SectionHead
        eyebrow="Por que a Flash Play TV?"
        title={
          <>
            Feita para você nunca mais ver tela travada.
          </>
        }
      />

      <div className="grid grid-cols-1 gap-5 md:grid-cols-12">
        <Reveal className="md:col-span-5" delay={0}>
          <div className={`${card} flex flex-col`}>
            <Gauge className="h-8 w-8 text-neon" />
            <h3 className="mt-5 font-display text-2xl font-bold uppercase tracking-tight text-white">
              Zero travamento
            </h3>
            <p className="mt-3 text-sm leading-relaxed text-mist">
              Servidores dedicados de alta velocidade, preparados para futebol
              ao vivo e maratonas de série — sem aquele congelamento no meio do
              gol.
            </p>
            <div className="relative mt-6 flex-1 overflow-hidden rounded-2xl border border-white/10">
              <img
                src={IMAGES.stadium}
                alt="Estádio em transmissão ao vivo"
                className="h-44 w-full object-cover transition-transform duration-700 group-hover:scale-105"
                loading="lazy"
              />
              <div
                className="pointer-events-none absolute inset-0"
                style={{
                  background:
                    "radial-gradient(circle at 30% 30%, rgba(138,43,226,0.3), transparent 60%), linear-gradient(to top, rgba(7,8,13,0.7), transparent 50%)",
                }}
                aria-hidden="true"
              />
            </div>
          </div>
        </Reveal>

        <Reveal className="md:col-span-3" delay={0.08}>
          <div className={`${card} flex flex-col justify-between`}>
            <p className="font-display text-7xl font-extrabold leading-none text-white">
              4K<span className="text-neon">.</span>
            </p>
            <div>
              <h3 className="mt-6 font-display text-xl font-bold uppercase tracking-tight text-white">
                Ultra HD + 60FPS
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-mist">
                Imagem de ponta nos esportes e no cinema, com nitidez de dar
                vontade de rever a jogada.
              </p>
            </div>
          </div>
        </Reveal>

        <Reveal className="md:col-span-4" delay={0.16}>
          <div className={`${card} relative overflow-hidden`}>
            <div className="absolute -right-16 -top-16 h-44 w-44 rounded-full bg-wa/15 blur-3xl" aria-hidden="true" />
            <Headset className="h-8 w-8 text-wa" />
            <h3 className="mt-5 font-display text-2xl font-bold uppercase tracking-tight text-white">
              Suporte humano 24/7
            </h3>
            <p className="mt-3 text-sm leading-relaxed text-mist">
              Atendimento direto no WhatsApp, com gente de verdade: sem robô,
              sem fila e sem espera para resolver o que for.
            </p>
            <p className="mt-6 font-mono text-[10px] uppercase tracking-[0.25em] text-wa">
              WhatsApp • resposta em minutos
            </p>
          </div>
        </Reveal>

        <Reveal className="md:col-span-4" delay={0}>
          <div className={card}>
            <History className="h-8 w-8 text-neon" />
            <h3 className="mt-5 font-display text-2xl font-bold uppercase tracking-tight text-white">
              EPG + Playback 7 dias
            </h3>
            <p className="mt-3 text-sm leading-relaxed text-mist">
              Guia de programação completo e replay de até 7 dias — perdeu o
              jogo ou o episódio? Assista quando quiser.
            </p>
          </div>
        </Reveal>

        <Reveal className="md:col-span-8" delay={0.08}>
          <div className={`${card} flex h-full flex-col justify-between gap-6`}>
            <div>
              <Zap className="h-8 w-8 text-neon" />
              <h3 className="mt-5 font-display text-2xl font-bold uppercase tracking-tight text-white">
                Ativação imediata, em qualquer aparelho
              </h3>
              <p className="mt-3 max-w-lg text-sm leading-relaxed text-mist">
                Pagou, assistiu. Enviamos o acesso na hora e você instala em
                poucos minutos — a gente guia você pelo WhatsApp do início ao
                fim.
              </p>
            </div>
            <div className="grid grid-cols-3 gap-3 sm:grid-cols-6" data-testid="device-list">
              {devices.map((d) => (
                <div
                  key={d.label}
                  className="flex flex-col items-center gap-2 rounded-2xl border border-white/10 bg-ink/60 px-2 py-4 transition-colors hover:border-neon/40"
                  data-testid="device-item"
                >
                  <d.icon className="h-5 w-5 text-white/80" />
                  <span className="text-center font-mono text-[9px] uppercase tracking-widest text-mist">
                    {d.label}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
